<div class="dialog-container state-dialog">
  <div class="dialog-body">
    <div class="title">{{'EXPIRED.OH' | translate}}</div>
    <div [innerHTML]="'EXPIRED.TEXT' | translate"></div>
    <div class="confirm-btn">
      <button class="w-btn orange-btn" (click)="seeOptions()">{{'EXPIRED.OPTIONS' | translate}}</button>
      <button class="w-link-btn" (click)="dialogRef.close()">{{'EXPIRED.NO' | translate}}</button>
    </div>
  </div>
</div>
